import React, { useEffect, useRef, useState } from "react";
import DashLayout from "../../../../../Components/Admin/AdminDashLayout";
import { Col, Row, Tabs } from "antd";
import { IoSearch } from "react-icons/io5";
import { MdOutlineFileCopy } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import TabPane from "antd/es/tabs/TabPane";
import toast from "react-hot-toast";
import { TbFileInvoice } from "react-icons/tb";
import { createReceipt, fetchReciptInvoiceData } from "../../../../../Store/Slices/Finance/Receipts/receiptsThunks";
import { Form, Input, Button, Select, DatePicker } from "antd";
import Layout from "../../../../../Components/Common/Layout";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { fetchAllEntityRevenue } from "../../../../../Store/Slices/Finance/EntityRevenue/EntityRevenue.thunk";
import { useTranslation } from "react-i18next";
import { fetchEntity } from "../../../../../Store/Slices/Finance/entitie/entity.thunk";


const CreateReceipt = () => {
  const { t } = useTranslation("prtFinance")
  const dispatch = useDispatch()
  const [searchInvoiceNumber, setSearchInvoiceNumber] = useState("");
  const [invoiceData, setInvoiceData] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalPaid, setTotalPaid] = useState(0);
  const [totalRemaining, setTotalRemaining] = useState(0);
  const [totalTax, setTotalTax] = useState(0);
  const [totalPenalty, setTotalPenalty] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [finalAmount, setFinalAmount] = useState(0);
  const [editableDiscounts, setEditableDiscounts] = useState({});
  const [editablePenalties, setEditablePenalties] = useState({});
  const [receiptData, setReceiptData] = useState({
    paymentType: "",
    paymentStatus: "",
    paidBy: "",
    paymentDate: '',
    paidItems: [],
    chequeNumber: "",
    chequeDate: null,
    bankAccount: "",
    onlineTransactionId: "",
    note: "",
    receiptData: null
  });

  const { bankEntities } = useSelector((s) => s.admin.entity);

  useEffect(() => {
    dispatch(fetchEntity({ search: "Bank", type: "bank", page: 1, limit: 1000 }));
  }, [dispatch]);

  const handlePayNowAmountChange = (e, lineItemId) => {
    const value = parseFloat(e.target.value) || 0;
    const discount = editableDiscounts[lineItemId] || 0;
    const penalty = editablePenalties[lineItemId] || 0;
    const item = invoiceData.lineItems.find(i => i._id === lineItemId);
    const values = calculateLineItemValues(item);
    const finalAmountForItem = values.remaining + item?.paid_amount;

    // Update paid item with discount and penalty
    const updatedItem = {
      lineItemId,
      amountPaid: value,
      discount,
      penalty,
      updatedRemainingAmount: (finalAmountForItem - item?.paid_amount).toFixed(2),
      finalAmount: finalAmountForItem
    };
    setReceiptData(prevData => {
      const existingIndex = prevData.paidItems.findIndex(item => item.lineItemId === lineItemId);
      if (existingIndex !== -1) {
        const updatedPaidItems = [...receiptData.paidItems];
        updatedPaidItems[existingIndex] = { ...updatedPaidItems[existingIndex], updatedItem };

        return { ...prevData, paidItems: updatedPaidItems };
      } else {
        const newItem = { lineItemId };
        return {
          ...prevData,
          paidItems: [...prevData.paidItems, newItem]
        };
      }
    });
  };

  const searchInvoice = () => {
    if (searchInvoiceNumber?.trim()?.split("-")?.length != 3) {
      toast.error(t("Please Enter Correct Invoice Number"));
      return
    }
    if (!["S", "E"].includes(searchInvoiceNumber.slice(-1))) {
      toast.error(t("Please Enter Correct Invoice Number"));
      return
    }
    dispatch(fetchReciptInvoiceData(searchInvoiceNumber)).then((data) => {
      setInvoiceData(data.payload?.invoice);
    })
  }
  const calculateLineItemValues = (item) => {
    const roundToFive = (num) => Math.round((num + Number.EPSILON) * 100000) / 100000;

    const baseAmount = item.rate * item.quantity;
    const penaltyAmount = parseFloat(editablePenalties[item._id] || 0);
    const taxAmount = roundToFive((baseAmount * (item.tax || 0)) / 100);
    let finalAmount = roundToFive(baseAmount + penaltyAmount + taxAmount);
    let discountAmount = 0;
    if (item.discountType === "percentage") {
      discountAmount = (finalAmount * (editableDiscounts[item._id] || 0)) / 100;
    } else {
      discountAmount = parseFloat(editableDiscounts[item._id] || 0);
    }

    finalAmount -= discountAmount;


    return {
      baseAmount: roundToFive(baseAmount),
      discountAmount: roundToFive(discountAmount),
      penaltyAmount: roundToFive(penaltyAmount),
      taxAmount: roundToFive(taxAmount),
      finalAmount: roundToFive(finalAmount),
      remaining: roundToFive(finalAmount - (item.paid_amount || 0)),
    };
  };

  // Calculate totals using the new line item calculations
  useEffect(() => {
    if (!invoiceData?.lineItems) return;

    let amount = 0;
    let paid = 0;
    let tax = 0;
    let discount = 0;
    let penalty = 0;
    let final = 0;

    invoiceData.lineItems.forEach((item) => {
      const values = calculateLineItemValues(item);
      amount += values.baseAmount;
      paid += item.paid_amount || 0;
      tax += values.taxAmount;
      discount += values.discountAmount;
      penalty += values.penaltyAmount;
      final += values.finalAmount;
    });
    setTotalAmount(amount);
    setTotalPaid(paid.toFixed(2));
    setTotalTax(tax);
    setTotalDiscount(discount);
    setTotalPenalty(penalty);
    setFinalAmount(final);
    setTotalRemaining(final - paid);
  }, [invoiceData, editableDiscounts, editablePenalties]);

  // FIX: Initialize discounts with invoice values instead of 0
  useEffect(() => {
    if (invoiceData?.lineItems) {
      const initialDiscounts = {};
      const initialPenalties = {};

      invoiceData.lineItems.forEach(item => {
        // Use invoice's discount value instead of 0
        initialDiscounts[item._id] = item.discount || 0;
        initialPenalties[item._id] = item.penalty_amount || 0;
      });

      setEditableDiscounts(initialDiscounts);
      setEditablePenalties(initialPenalties);
    }
  }, [invoiceData]);

  const handleDiscountChange = (lineItemId, value) => {
    setEditableDiscounts(prev => ({
      ...prev,
      [lineItemId]: value
    }));
  };

  // Handle penalty changes
  const handlePenaltyChange = (lineItemId, value) => {
    setEditablePenalties(prev => ({
      ...prev,
      [lineItemId]: value
    }));
  };

  const handleChange = (field, value) => {
    setReceiptData({
      ...receiptData,
      [field]: field.includes('Date') && value ? value.format('YYYY-MM-DD') : value,
    });
  };
  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      setSearchInvoiceNumber(text);
    } catch (error) {
      console.error("Failed to read clipboard contents: ", error);
    }
  }

  const { activeYear } = useSelector((store) => store.common.financialYear);
  const minDate = dayjs(activeYear?.startDate?.slice(0, 10));
  const maxDate = dayjs(activeYear?.endDate?.slice(0, 10));
  const navigate = useNavigate()

  return (
    <Layout title="Finance | Create Reciept">
      <DashLayout>

        <div className="p-4 ">
          <div className="flex flex-row items-start gap-4">
            <div className="flex flex-row items-center relative">
              <input type="text" className="w-[20rem] h-[2.5rem] p-2 border border-gray-400 rounded-xl" placeholder={t("Enter Invoice Number")} onChange={(e) => setSearchInvoiceNumber(e.target.value)} value={searchInvoiceNumber} />
              <MdOutlineFileCopy title={t("Paste")} className="absolute end-1 cursor-pointer" size={20} onClick={() => handlePaste()} />
            </div>
            <div>
              <button className="flex flex-row items-center gap-2 btn-gradient h-[2.5rem]" onClick={() => searchInvoice()}> <IoSearch /> {t("Search")}</button>
            </div>
          </div>
          {invoiceData?.isCancel && (
            <div className="bg-red-100 text-red-600 p-3 rounded my-4">
              {t("This invoice is cancelled. Payment is not allowed.")}
            </div>
          )}

          {invoiceData ?
            <Tabs className="mt-4">
              <TabPane tab="Invoice Details" key="1" >
                <div className="flex flex-col ">
                  <div>
                    <div className="w-full text-center rounded-t-xl  font-bold py-2 bg-gradient-to-r from-pink-600  to-violet-600   border-none text-white px-3  shadow-purple-glow
                      transition-colors duration-200;" style={{ fontSize: "18px" }}>
                      {t("INVOICE")} {invoiceData?.isCancel && t("CANCELLED")}
                    </div>
                  </div>

                  <div className="text-sm text-gray-800 mb-4 p-4 flex justify-between">
                    {invoiceData?.studentId && (
                      <div>
                        <p><strong>{t("Bill To")}</strong></p>
                        <p><strong>{t("Name")}:</strong> {invoiceData?.studentId?.firstName} {invoiceData?.studentId?.lastName}</p>
                        <p><strong>{t("Email")}:</strong> {invoiceData?.studentId?.email}</p>
                        <p><strong>{t("Contact")}:</strong> {invoiceData?.studentId?.contactNumber}</p>
                      </div>
                    )}
                    {invoiceData?.entityId && (
                      <div>
                        <p><strong>{t("Bill To")}:</strong></p>
                        <p><strong>{t("Name")}:</strong> {invoiceData?.entityId?.entityName}</p>
                        <p><strong>{t("Email")}:</strong> {invoiceData?.entityId?.email}</p>
                        <p><strong>{t("Contact")}:</strong> {invoiceData?.entityId?.contactNumber}</p>
                      </div>
                    )}
                    <div>
                      <p><strong>{t("Invoice No")}:</strong> {invoiceData?.InvoiceNumber || ""}</p>
                      <p><strong>{t("Issue Date")}:</strong> {invoiceData?.generateDate?.slice(0, 10)}</p>
                      <p><strong>{t("Status")}:</strong> {totalPaid == 0 ? t("Unpaid") : totalPaid == finalAmount ? t("Paid") : t("Partial")}</p>
                      <p><strong>{t("Currency")}:</strong> {invoiceData?.schoolId?.currency}</p>
                    </div>

                  </div>

                  <table className="w-full text-[15px] mb-6 border border-gray-300">
                    <thead>
                      <tr className="bg-pink-100 text-start">
                        <th className="p-2 border">{t("Item")}</th>
                        <th className="p-2 border">{t("Item Detail")}</th>
                        <th className="p-2 border">{t("Rate")}</th>
                        <th className="p-2 border">{t("Qty")}</th>
                        <th className="p-2 border">{t("Tax (%)")}</th>
                        <th className="p-2 border">{t("Penalty")}</th>
                        <th className="p-2 border">{t("Discount")}</th>
                        <th className="p-2 border">{t("Total")}</th>
                        <th className="p-2 border">{t("Paid")}</th>
                        <th className="p-2 border">{t("Balance")}</th>
                        <th className="p-2 border">{t("Due Date")}</th>
                        <th className="p-2 border">{t("Pay Now")}</th>
                      </tr>

                    </thead>
                    <tbody className="text-sm">
                      {invoiceData?.lineItems.map((item, index) => {
                        const values = calculateLineItemValues(item);
                        return (
                          <tr key={item._id || index} className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                            <td className="p-2 border">{item.name || "N/A"}</td>
                            <td className="p-2 border">{item.itemDetails} <br /> {item.frequency !== "Permanent Purchase" && ` ${item.frequency} from ${item?.startDate?.slice(0, 10)} to ${item?.endDate?.slice(0, 10)}`}</td>
                            <td className="p-2 border text-start">{item.rate}</td>
                            <td className="p-2 border text-start">{item.quantity || 1}</td>
                            <td className="p-2 border text-start">{item.tax}</td>
                            <td className="p-2 border text-center">
                              {!invoiceData?.isCancel ? (
                                <>
                                  {/* Editable penalty field */}
                                  <input
                                    type="number"
                                    min="0"
                                    className="w-[6rem] border text-center border-gray-300 rounded-xl p-1"
                                    value={editablePenalties[item._id] || 0}
                                    onChange={(e) => handlePenaltyChange(item._id, e.target.value)}
                                    onPaste={(e) => e.preventDefault()}
                                    onWheel={(e) => e.target.blur()}
                                  />
                                </>
                              ) : (
                                <span>{editablePenalties[item._id] || 0}</span>
                              )}

                            </td>
                            <td className="p-2 border text-center">
                              <div className="flex items-center gap-1">
                                {invoiceData?.isCancel ? (
                                  <>
                                    <span>{editableDiscounts[item._id] || 0}</span>
                                    {item.discountType === "percentage" && <span>%</span>}
                                  </>
                                ) : (
                                  <>
                                    <input
                                      type="number"
                                      min="0"
                                      className="w-[6rem] border text-center border-gray-300 rounded-xl p-1"
                                      value={editableDiscounts[item._id] || 0}
                                      onChange={(e) => handleDiscountChange(item._id, e.target.value)}
                                      onPaste={(e) => e.preventDefault()}
                                      onWheel={(e) => e.target.blur()}
                                    />
                                    {item.discountType === "percentage" && <span>%</span>}
                                  </>
                                )}
                              </div>
                            </td>

                            <td className="p-2 border text-start">{values.finalAmount}</td>
                            <td className="p-2 border text-start">{item.paid_amount || 0}</td>
                            <td className="p-2 border text-start">{values.remaining}</td>
                            <td className="p-2 border text-start">{item?.dueDate?.slice(0, 10) || " "}</td>
                            <td className="ps-1 border text-start">
                              <input
                                type="number"
                                className="w-[9rem] border border-gray-300 rounded-xl p-2"
                                onChange={(e) => handlePayNowAmountChange(e, item._id)}
                                placeholder={t("Enter Amount")}
                                disabled={invoiceData?.isCancel}
                                onPaste={(e) => e.preventDefault()}       // ❌ Block paste
                                onWheel={(e) => e.target.blur()}          // ❌ Prevent scroll changing value
                              />
                            </td>

                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                  <div className="flex flex-row items-center border border-gray-300 text-xs ">
                    <div className="flex flex-col items-start p-4 w-[60%]">
                      <p>{t("Payment Details")}</p>
                      <div className="w-full h-[90%]">

                      </div>

                    </div>
                    <div className="flex flex-col items-start p-4 w-[40%] border-s-2 border-gray-300 text-sm">
                      <p><strong>{t("Total Amount")}</strong> = {totalAmount} {invoiceData?.schoolId?.currency}</p>
                      <p><strong>{t("Total Discount")}</strong> = {totalDiscount} {invoiceData?.schoolId?.currency}</p>
                      <p><strong>{t("Total Penalty")}</strong> = {totalPenalty} {invoiceData?.schoolId?.currency}</p>
                      <p><strong>{t("Total Tax")}</strong> = {totalTax.toFixed(2)} {invoiceData?.schoolId?.currency}</p>
                      <p className="border-t mt-2"><strong>{t("Final Amount")}</strong> = {finalAmount.toFixed(2)} {invoiceData?.schoolId?.currency}</p>
                      <p><strong>{t("Total Paid")}</strong> = {totalPaid} {invoiceData?.schoolId?.currency}</p>
                      <p><strong>{t("Total Remaining")}</strong> = {totalRemaining.toFixed(2)} {invoiceData?.schoolId?.currency}</p>
                    </div>

                  </div>

                </div>
                {
                  !invoiceData?.isCancel && (
                    <Form
                      layout="vertical"
                      onFinish={() => {
                        dispatch(createReceipt({
                          ...receiptData, invoiceNumber: searchInvoiceNumber

                        }
                        )).then((res) => {
                          if (res?.payload.success) {
                            fetchAllEntityRevenue()
                            navigate("/finance/receipts/receipt-list")
                          }
                        }
                        )
                      }

                      }
                      initialValues={receiptData}
                      className="mt-4"
                    >
                      {/* Row 1 */}
                      <Row gutter={16}>
                        <Col span={6}>
                          <Form.Item label="Payment Type" name="paymentType" rules={[{ required: true, message: "Payment Type is required" }]} >
                            <Select
                              value={receiptData.paymentType}
                              onChange={(value) => handleChange("paymentType", value)}
                            >
                              <Select.Option value="cash">{t("Cash")}</Select.Option>
                              <Select.Option value="card">{t("Card")}</Select.Option>
                              <Select.Option value="online">{t("Online")}</Select.Option>
                              <Select.Option value="cheque">{t("Cheque")}</Select.Option>
                              <Select.Option value="other">{t("Other")}</Select.Option>

                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={6}>
                          <Form.Item label={t("Payment Date")} name="paymentDate" rules={[{ required: true, message: t("Payment Date is required") }]}>
                            <DatePicker type="date"
                              className="w-[15rem] h-[2rem] border border-gray-300 rounded-xl p-2"
                              value={receiptData.paymentDate}
                              onChange={(value) => handleChange("paymentDate", value)}
                              disabledDate={(current) =>
                                current && (current.isBefore(minDate, 'day') || current.isAfter(maxDate, 'day'))
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col span={6}>
                          <Form.Item label={t(`Payer Full Name`)} name="paidBy" rules={[{ required: true, message: t("Payer Name is required") }]}>
                            <Input
                              value={receiptData.paidBy}
                              placeholder={t("Payer Full Name")}
                              onChange={(e) => handleChange("paidBy", e.target.value)}
                            />
                          </Form.Item>
                        </Col>
                        {/* Conditional Fields */}
                        {(receiptData.paymentType === "online" || receiptData.paymentType === "card") ? (
                          <>
                            <Col span={6}>
                              <Form.Item name="bankAccount" label="Bank Account">
                                <Select
                                  value={receiptData.bankAccount}
                                  onChange={(value) => handleChange("bankAccount", value)}
                                  placeholder="Select bank entity"
                                  allowClear
                                  showSearch
                                  options={bankEntities.map((e) => ({
                                    label: e.entityName,
                                    value: e._id
                                  }))}
                                />
                              </Form.Item>
                            </Col>
                          </>
                        ) : null}

                        {/* Conditional Fields for Cheque */}
                        {receiptData.paymentType === "cheque" && (
                          <>
                            <Col span={6}>
                              <Form.Item label={t("Cheque Number")} name="chequeNumber" rules={[{ required: true, message: t("Cheque Number is required") }]}>
                                <Input
                                  value={receiptData.chequeNumber}
                                  onChange={(e) => handleChange("chequeNumber", e.target.value)}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={6}>
                              <Form.Item label={t("Cheque Date")} name="chequeDate" >
                                <DatePicker type="date"
                                  className="w-[15rem] h-[2rem] border border-gray-300 rounded-xl p-2"
                                  value={receiptData.chequeDate}
                                  onChange={(value) => handleChange("chequeDate", value)}
                                  disabledDate={(current) =>
                                    current && (current.isBefore(minDate, 'day') || current.isAfter(maxDate, 'day'))
                                  }
                                />
                              </Form.Item>
                            </Col>
                          </>
                        )}
                      </Row>


                      {/* Row 2*/}
                      <Row gutter={16}>
                        <Col span={6}>
                          <Form.Item label={t("Note")} name="note">
                            <Input.TextArea
                              value={receiptData.note}
                              onChange={(e) => handleChange("note", e.target.value)}
                            />
                          </Form.Item>
                        </Col>
                      </Row>

                      <button
                        className="btn-gradient text-white px-4"
                        type="submit"
                      >
                        {t("Submit")}
                      </button>
                    </Form>
                  )
                }

              </TabPane>

              {/* <TabPane tab="OverDue Invoices" key="2">
        
          </TabPane> */}
            </Tabs> : <div className="w-full h-[80vh] flex flex-col items-center justify-center">
              <p className="text-gray-500">{t("Enter or Paste Invoice Number and Get Data")}</p>
              <p className="text-gray-500"><TbFileInvoice size={50} /></p>
            </div>}

        </div>
      </DashLayout>
    </Layout>
  );
};

export default CreateReceipt;